module.exports = __webpack_public_path__ + "static/media/slide2.e0f1073a.png";